import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const durationService = {
    getDuration: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.MESSAGES}/${API_PATH.DURATIONS}`);
    }
};

export default durationService;
